<template src='./project-options.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import ProjectOrganizations from './organizations/ProjectOrganizations'
import ProjectAppropriations from './appropriations/ProjectAppropriations'
import ProjectSettings from './settings/ProjectSettings'
import ProjectLists from './lists/ProjectLists'
import ProjectMerging from './merging/ProjectMerging'
import FileSaver from 'file-saver'
import { EventBus } from '@/router/bus'

export default {
  components: {
    ContextPage,
    'project-organizations': ProjectOrganizations,
    'project-appropriations': ProjectAppropriations,
    'project-settings': ProjectSettings,
    'project-lists': ProjectLists,
    'project-merging': ProjectMerging
  },
  props: ['canUserViewMergingTabPage', 'canUserViewListsTabPage', 'project'],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      tab: null,
      archiveConfirmation: false,
      archiveProject: {
        comment: '',
        projectNumber: ''

      },
      projectStatus: {
        PENDING: 0,
        FINISHED: 1,
        ARCHIVED: 3
      }
    }
  },
  created () {
    EventBus.$emit('reload-crumbs')
  },
  mounted () {
    const routeTab = this.$route.path.split('/')[4]
    if (this.tab !== routeTab) {
      this.tab = routeTab
    }
  },
  methods: {
    tabChanged (tab) {
      history.pushState({}, null, '/projects/' + this.projectCode + '/project/options' + `${'/' + tab}`)
      EventBus.$emit('reload-crumbs')
      EventBus.$emit('subTab', tab)
    },
    exportOptions (format) {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.generateOptionsGet.replace('{projectCode}', this.$route.params.projectCode) + '?format=' + format, { responseType: 'arraybuffer' })
        .then(
          response => {
            var headers = response.headers
            var blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, this.projectCode + '-opcije.' + format)
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    archiveProjectConfirmation () {
      console.log(this.project)
      this.archiveConfirmation = true
    },
    archiveProjectApprove () {
      this.archiveConfirmation = false
      this.archiveProject.projectNumber = this.project.number
      this.showLoader(true)
      this.$http.put(Vue.$apiConfig.archiveProject, this.archiveProject)
        .then(
          response => {
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('contextPath.archiveSuccess'),
              errors: []
            })
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>

<style>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}
</style>
